
import React, { useState, useEffect } from 'react';
import './Promotion.css';
import Select from 'react-select';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from "react-router-dom";
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { capitalizeFirstLetter } from '../../../utils/validations';
import { getDistrict, getStates } from '../../../services/monthlyAttendanceService';
import { getEmployyesforTransfor } from '../../../services/transport';
import { format } from 'date-fns';
import { getAuditLog } from '../../../utils/calculateDaysInMonthUtils';
import { getDesignationsForEmployees } from '../../../services/shiftsService';

const Promotion = () => {
    const navigate = useNavigate();
    const [employees, setEmployees] = useState([]);
    const [employeeName, setEmployeeName] = useState(null);
    const [designation, setDesignation] = useState("");
    const [draftId, setDraftId] = useState("");
    const [presentState, setPresentState] = useState("");
    const [presentDistrict, setPresentDistrict] = useState("");
    const [presentLocation, setPresentLocation] = useState("");
    const [fromDate, setFromDate] = useState(null);

    const [isFocused, setIsFocused] = useState({
        employeeName: false,
        reportingTo: false,
        fromDate: false
    });

    const [promotionState, setPromotionState] = useState(null);
    const [promotionDistrict, setPromotionDistrict] = useState(null);
    const [promotionBlock, setPromotionBlock] = useState(null);
    const [reportingTo, setReportingTo] = useState(null);
    const [state, setState] = useState(3);
    const [district, setDistrict] = useState(null);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [blockOptions, setBlockOptions] = useState([]);
    const [reportingOptions, setReportingOptions] = useState([]);
    const [errors, setErrors] = useState({});
    const [promotionDesignation, setPromotionDesignation] = useState(null);
    const [toLocation, setToLocation] = useState(null);
    const [designationOptions, setDesignationOptions] = useState([]);
    const [locationOptions, setLocationOptions] = useState([]);


    const [desginationsForEmployees, setDesignationForEmployees] = useState([]);
    const [seletedDesignation, setSelectedDesignation] = useState('');

    useEffect(() => {
        const fetchEmployees = async () => {
            try {
                const response = await getEmployyesforTransfor(state, district, seletedDesignation);
                const data = response.data;

                if (Array.isArray(data)) {
                    setEmployees(
                        data.map((item) => ({
                            value: item.employeeUniqueId,               // or item.promotionId if needed
                            label: `${item.fullName} - ${item.contactNumber}`,
                            designation: item.designation || "",
                            presentState: item.stateName || "",
                            presentDistrict: item.districtName || "",
                            // We'll compute presentLocation dynamically later
                            workLocations: item.workLocations || [],
                            godowns: item.godowns || [],
                            draftId: item.employeeId,                    // assuming draftId is employeeId
                            raw: item
                        }))
                    );
                }
            } catch (error) {
                console.error("Error fetching employees:", error);
                setErrors(prev => ({ ...prev, general: "Error fetching employees" }));
            }
        };

        if (district) {
            fetchEmployees();
        } else {
            setEmployees([]);
        }
    }, [district, state, seletedDesignation]); // Keep state if filtering by state too
    useEffect(() => {

        const fetchStates = async () => {
            try {
                const res = await getStates();
                setStateOptions(res.map(item => ({
                    value: item.id,
                    label: capitalizeFirstLetter(item.stateName)
                })));
            } catch (err) {
                setErrors(prev => ({ ...prev, general: "Failed to load states" }));
            }
        };


        fetchStates();
    }, []);
    useEffect(() => {
        if (state) {
            const fetchDistricts = async () => {
                try {
                    const data = await getDistrict(state);
                    setDistrictOptions(
                        data.map(item => ({
                            value: item.districtId,
                            label: item.districtName,
                        }))
                    );
                } catch (error) {
                    console.error('Error fetching districts:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
                }
            };
            fetchDistricts();
        } else {
            setDistrictOptions([]);
            setDistrict(null);
        }
    }, [state]);

    useEffect(() => {
        if (promotionState) {
            const fetchDistricts = async () => {
                try {
                    const res = await getDistrict(promotionState);
                    setDistrictOptions(res.map(item => ({
                        value: item.districtId,
                        label: item.districtName
                    })));
                } catch (err) {
                    setErrors(prev => ({ ...prev, general: "Failed to load districts" }));
                }
            };
            fetchDistricts();
        } else {
            setDistrictOptions([]);
            setPromotionDistrict(null);
        }
    }, [promotionState]);



    // normal designation api

    useEffect(() => {
        const fetchDesignationForEmployyes = async () => {
            try {
                const response = await getDesignationsForEmployees();
                const options = response.map(item => ({
                    value: item.id,
                    label: item.designationName,
                    shortName: item.designationShortName,
                }));
                setDesignationForEmployees(options);
            }
            catch (error) {
                console.log("Get all Designations before fetching ");
            }
        };
        fetchDesignationForEmployyes();
    }, [])


    // Promotion designation api
    useEffect(() => {
        const fetchDesignations = async () => {
            const selectedObj = desginationsForEmployees.find((item) => item.value === seletedDesignation);

            if (selectedObj && selectedObj.shortName) {
                try {
                    //const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/designations/dropdown/by-designation?shortName=${selectedObj.shortName}`);
                    const response = await getDesignationsForEmployees();
                    const options = response.map(item => ({
                        value: item.id,
                        label: item.designationName,
                        // Use the specific shortName for THIS item (e.g., CMR_DEO)
                        shortName: item.designationShortName
                    }));
                    setDesignationOptions(options);
                } catch (error) {
                    console.error('Error fetching designations:', error);
                }
            } else {
                setDesignationOptions([]);
            }
        };
        fetchDesignations();
    }, [seletedDesignation, desginationsForEmployees]);

    useEffect(() => {
        if (promotionDistrict) {
            const fetchLocation = async () => {
                try {
                    const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/locations/dropdown/by-district/${promotionDistrict}`);
                    setLocationOptions(res.data.map(item => ({
                        value: item.id,
                        label: item.name,
                        type: item.type // Store the type (TPDS or DHQ)
                    })));
                } catch (err) {
                    console.error('Error fetching locations:', err);
                    setErrors(prev => ({ ...prev, general: 'Failed to load locations' }));
                }
            };
            fetchLocation();
        }
    }, [promotionDistrict]);

    // Add this logic inside your component render or right before the return
    const getFilteredLocations = () => {
        const selectedPromotion = designationOptions.find(opt => opt.value === promotionDesignation);

        if (!selectedPromotion) return locationOptions;

        // Use the shortName we stored in the fetchDesignations effect
        const sName = selectedPromotion.shortName?.toUpperCase() || "";

        // Group definitions
        const dhqDesignations = ["CRO", "ITM_TPDS", "ITM_PPC", "HDO", "HDOP", "PMDC", "SYSTEM_ADMIN", "APM", "CCO",];
        const cmrDesignations = ["CMR_DEO", "CMR"];
        const tpdsDesignations = ["DEO", "FCI_DEO", "TPDS"];

        console.log("Filtering for Designation ShortName:", sName);

        // 1. Logic for DHQ
        if (dhqDesignations.includes(sName)) {
            return locationOptions.filter(loc => loc.type === "DHQ");
        }

        // 2. Logic for CMR (Now explicitly checks CMR_DEO)
        if (cmrDesignations.includes(sName)) {
            return locationOptions.filter(loc => loc.type === "CMR");
        }

        // 3. Logic for TPDS
        if (tpdsDesignations.includes(sName)) {
            return locationOptions.filter(loc => loc.type === "TPDS");
        }

        // 4. Fallback: Show everything except DHQ if no specific match is found
        return locationOptions.filter(loc => loc.type !== "DHQ");
    };





    // Update this useEffect for fetching reporting managers
    useEffect(() => {
        if (promotionDistrict && promotionDesignation) {  // Added promotionDesignation condition
            const fetchManagers = async () => {
                // Find the selected promotion designation object from designationOptions
                const selectedPromotionDesignation = designationOptions.find(
                    (item) => item.value === promotionDesignation
                );

                if (selectedPromotionDesignation && selectedPromotionDesignation.shortName) {
                    try {
                        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/list/reporting/promotion?districtId=${promotionDistrict}&designation=${selectedPromotionDesignation.shortName}`);
                        setReportingOptions(res.data.map(item => ({
                            value: item.employeeloginId,
                            label: item.fullName,
                        })));
                    } catch (err) {
                        console.error('Error fetching managers:', err);
                        setErrors(prev => ({ ...prev, general: 'Failed to load reporting managers' }));
                    }
                }
            };                                                                                                                                                     
            fetchManagers();
        } else {
            // Clear reporting options when district or promotion designation is not selected
            setReportingOptions([]);
            setReportingTo(null);
        }
    }, [promotionDistrict, promotionDesignation, designationOptions]); // Updated dependencies

    const handleInputChange = (selectedOption, field) => {
        const value = selectedOption ? selectedOption.value : null;

        switch (field) {
            case "employeeName":
                setEmployeeName(selectedOption ? selectedOption.value : null);
                if (selectedOption) {
                    setDesignation(selectedOption.designation || "");
                    setDraftId(selectedOption.draftId || "");
                    setPresentState(selectedOption.presentState || "");
                    setPresentDistrict(selectedOption.presentDistrict || "");

                    // New logic for presentLocation
                    const locations = selectedOption.workLocations;
                    const godowns = selectedOption.godowns;

                    let locationDisplay = "";
                    if (Array.isArray(locations) && locations.length > 0) {
                        locationDisplay = locations.join(", ");
                    } else if (Array.isArray(godowns) && godowns.length > 0) {
                        locationDisplay = godowns.join(", ");
                    } else {
                        locationDisplay = "N/A";
                    }

                    setPresentLocation(locationDisplay);
                } else {
                    setDesignation("");
                    setDraftId("");
                    setPresentState("");
                    setPresentDistrict("");
                    setPresentLocation("");
                }
                break;

            case 'designationForEmp':
                setSelectedDesignation(value);
                setPresentLocation('');
                setEmployeeName('');
                setPromotionDesignation('');
                break;

            case 'state':
                setState(value);
                setDistrict(null);
                break;
            case 'district':
                setDistrict(value);
                break;
            case "promotionState":
                setPromotionState(value);
                setPromotionDistrict(null); // Use null instead of ''
                setToLocation(null);      // Clear the selection
                setLocationOptions([]);   // Clear the options list immediately
                break;
            case "promotionDistrict":
                setPromotionDistrict(value);
                setToLocation(null);
                setReportingTo(null); // Clear reporting manager when district changes
                setReportingOptions([]); // Clear options
                break;

            case "promotionBlock":
                setPromotionBlock(value);
                break;
            case "reportingTo":
                setReportingTo(value);
                break;
            case "promotionDesignation":
                setPromotionDesignation(value);
                setReportingTo(null); // Clear previously selected reporting manager
                setReportingOptions([]); // Clear options until new ones are fetched
                break;
            case "toLocation":
                setToLocation(selectedOption || []);
                break;
            default:
                break;


        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!employeeName) newErrors.employeeName = "Employee Name is required";
        if (!promotionState) newErrors.promotionState = "To State is required";
        if (!promotionDistrict) newErrors.promotionDistrict = "To District is required";
        if (!reportingTo) newErrors.reportingTo = "Reporting To is required";
        if (!fromDate) newErrors.fromDate = "From Date is required";
        if (!promotionDesignation) newErrors.promotionDesignation = "Promotion Designation is required";
        if (!toLocation) newErrors.toLocation = "To Location is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleClear = () => {
        setEmployeeName(null);
        setDesignation("");
        setDraftId("");
        setState('');
        setPresentState("");
        setPresentDistrict("");
        setPresentLocation("");
        //setDesignationForEmployees([]);
        setSelectedDesignation(null);
        setFromDate(null);
        setPromotionState(null);
        setPromotionDistrict(null);
        setPromotionBlock(null);
        setReportingTo(null);
        setPromotionDesignation(null);
        setToLocation(null);
        setErrors({});
    };

    const handleSave = async () => {
        if (!validateForm()) return;

        // FIX: Include both TPDS and CMR types for the godown array
        const godownIds = toLocation
            .filter(loc => loc.type === "TPDS" || loc.type === "CMR")
            .map(loc => loc.value);

        const dhqLocation = toLocation.find(loc => loc.type === "DHQ");

        const payload = {
            employeeUniqueId: employeeName,
            toDesignationId: promotionDesignation,
            effectiveDate: format(fromDate, 'yyyy-MM-dd'),
            toStateId: promotionState,
            toDistrictId: promotionDistrict,
            reportingTo,
            remarks: "Transferred with multiple godown responsibility",
            auditLog: getAuditLog(),
        };

        // If godowns were selected (either TPDS or CMR), add to payload
        if (godownIds.length > 0) {
            payload.toGodownIds = godownIds;
        }

        if (dhqLocation) {
            payload.toWorkLocationId = dhqLocation.value;
        }

        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/promotions`, payload
            );
            alert("Employee transfer saved successfully!");
            handleClear();
        } catch (err) {
            setErrors(prev => ({
                ...prev,
                general: err.response?.data?.message || "Error saving employee transfer"
            }));
        }
    };

    // const selectStyles = {
    //     menuPortal: base => ({ ...base, zIndex: 9999 }),
    //     menu: base => ({ ...base, marginTop: "5px", zIndex: 9999 }),
    //     control: provided => ({ ...provided, padding: "1px" }),
    //     valueContainer: provided => ({ ...provided, padding: "3px 6px" })
    // };

    return (
        <div className="employee-promotion-maincontainer">
            <div className="employee-promotion-box">
                <h2 className="employee-promotion-heading">Employee Promotion</h2>
                {errors.general && <div className="error-message">{errors.general}</div>}

                <div className="employee-promotion-structure-heading">

                    <div className='promotion-border'>
                        <span className='promotion-designation-head'> Present Designation </span>
                        <div className="employee-promotion-maincontainer-1">
                            <div className="employee-promotion-container-part">
                                <div className={`employee-promotion-floating-label-container-2 ${isFocused.state || state ? 'float-label' : ''}`}>
                                    <Select
                                        name="state"
                                        options={stateOptions}
                                        value={stateOptions.find(opt => opt.value === state) || null}
                                        onChange={option => handleInputChange(option, 'state')}
                                        onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                        placeholder=" "
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={selectStyles}

                                    />
                                    <label><span className="required">*</span>State</label>
                                    {errors.state && <div className="error-message">{errors.state}</div>}
                                </div>
                            </div>
                            <div className="employee-promotion-container-part">
                                <div className={`employee-promotion-floating-label-container-2 ${isFocused.district || district ? 'float-label' : ''}`}>
                                    <Select
                                        name="district"
                                        options={districtOptions}
                                        value={districtOptions.find(opt => opt.value === district) || null}
                                        onChange={option => handleInputChange(option, 'district')}
                                        onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                                        placeholder=" "
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={selectStyles}

                                    />
                                    <label><span className="required">*</span>District</label>
                                    {errors.district && <div className="error-message">{errors.district}</div>}
                                </div>
                            </div>
                        </div>

                        {/* Employee Dropdown */}
                        <div className="employee-promotion-maincontainer-1">
                            <div className="employee-promotion-container-part">
                                <div className={`employee-promotion-floating-label-container-2 ${isFocused.seletedDesignation || seletedDesignation ? "float-label" : ""}`}>
                                    <Select
                                        name='designation'
                                        options={desginationsForEmployees}
                                        // This ensures that if the ID is null/empty, the Select component resets to empty
                                        value={desginationsForEmployees.find(opt => opt.value === seletedDesignation) || null}
                                        onChange={(option) => handleInputChange(option, "designationForEmp")}
                                        isClearable
                                    />
                                    <label><span className="required">*</span>Designation</label>
                                </div>
                            </div>


                            <div className="employee-promotion-container-part">
                                <div className={`employee-promotion-floating-label-container-2 ${isFocused.employeeName || employeeName ? "float-label" : ""}`}>
                                    <Select
                                        name="employeeName"
                                        options={employees}
                                        value={employees.find(opt => opt.value === employeeName) || null}
                                        onChange={(option) => handleInputChange(option, "employeeName")}
                                        onFocus={() => setIsFocused(prev => ({ ...prev, employeeName: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, employeeName: false }))}
                                        placeholder=" "
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={selectStyles}
                                    />
                                    <label><span className="required">*</span>Employee Name</label>
                                    {errors.employeeName && <div className="error-message">{errors.employeeName}</div>}
                                </div>
                            </div>

                        </div>

                        {/* Read-only employee details */}

                        <div className="employee-promotion-maincontainer-1">

                            <div className="employee-promotion-container-part">
                                <div className="employee-promotion-floating-label-container-2">
                                    <input type="text" value={presentLocation} readOnly placeholder=" " disabled />
                                    <label>Present Location</label>
                                </div>
                            </div>
                            <div className="employee-promotion-container-part">
                                {/* <div className="employee-promotion-floating-label-container-2">
                                <input type="text" value={presentDistrict} readOnly placeholder=" " />
                                <label>Present District</label>
                            </div> */}
                            </div>
                        </div>

                    </div>

                    <div className='promotion-border'>
                        <span className='promotion-designation-head'>Changing Designation</span>
                        <div className="employee-promotion-maincontainer-1">
                            <div className="employee-promotion-container-part">
                                <div className={`employee-promotion-floating-label-container-2 ${promotionState ? "float-label" : ""}`}>
                                    <Select
                                        name="promotionState"
                                        options={stateOptions}
                                        value={stateOptions.find(opt => opt.value === promotionState) || null}
                                        onChange={(option) => handleInputChange(option, "promotionState")}
                                        placeholder=" "
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={selectStyles}
                                    />
                                    <label><span className="required">*</span>Posted State</label>
                                    {errors.promotionState && <div className="error-message">{errors.promotionState}</div>}
                                </div>
                            </div>
                            <div className="employee-promotion-container-part">
                                <div className={`employee-promotion-floating-label-container-2 ${promotionDistrict ? "float-label" : ""}`}>
                                    <Select
                                        name="promotionDistrict"
                                        options={districtOptions}
                                        value={districtOptions.find(opt => opt.value === promotionDistrict) || null}
                                        onChange={(option) => handleInputChange(option, "promotionDistrict")}
                                        placeholder=" "
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={selectStyles}
                                    />
                                    <label><span className="required">*</span>Posted District</label>
                                    {errors.promotionDistrict && <div className="error-message">{errors.promotionDistrict}</div>}
                                </div>
                            </div>
                        </div>
                        <div className="employee-promotion-maincontainer-1">
                            <div className="employee-promotion-container-part">
                                <div className={`employee-promotion-floating-label-container-2 ${promotionDesignation ? "float-label" : ""}`}>
                                    <Select
                                        name="promotionDesignation"
                                        options={designationOptions}
                                        value={designationOptions.find(opt => opt.value === promotionDesignation) || null}
                                        onChange={(option) => handleInputChange(option, "promotionDesignation")}
                                        placeholder=" "
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={selectStyles}
                                    />
                                    <label><span className="required">*</span>Promotion Designation</label>
                                    {errors.promotionDesignation && <div className="error-message">{errors.promotionDesignation}</div>}
                                </div>
                            </div>
                            <div className="employee-promotion-container-part">
                                <div className={`employee-promotion-floating-label-container-2 ${toLocation && toLocation.length > 0 ? "float-label" : ""}`}>
                                    <Select
                                        name="toLocation"
                                        // Use the filtered function here
                                        options={getFilteredLocations()}
                                        value={toLocation}
                                        onChange={(option) => handleInputChange(option, "toLocation")}
                                        placeholder=" "
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={selectStyles}
                                        isMulti={true}
                                    />
                                    <label><span className="required">*</span>Work Location</label>
                                    {errors.toLocation && <div className="error-message">{errors.toLocation}</div>}
                                </div>
                            </div>
                        </div>

                        <div className="employee-promotion-maincontainer-1">
                            <div className="employee-promotion-container-part">
                                <div className={`employee-promotion-floating-label-container-2 ${reportingTo ? "float-label" : ""}`}>
                                    <Select
                                        name="reportingTo"
                                        options={reportingOptions}
                                        value={reportingOptions.find(opt => opt.value === reportingTo) || null}
                                        onChange={(option) => handleInputChange(option, "reportingTo")}
                                        placeholder=" "
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={selectStyles}

                                    />
                                    <label><span className="required">*</span>Reporting To</label>
                                    {errors.reportingTo && <div className="error-message">{errors.reportingTo}</div>}
                                </div>
                            </div>
                            <div className="employee-promotion-container-part">
                                <div className={`employee-promotion-floating-label-container-2 ${fromDate ? "float-label" : ""}`}>
                                    <DatePicker
                                        selected={fromDate}
                                        onChange={(date) => {
                                            setFromDate(date);
                                            setErrors(prev => ({ ...prev, fromDate: null }));
                                        }}
                                        dateFormat="dd-MM-yyyy"
                                        placeholderText=" "
                                        className="date-picker-input"
                                    // minDate={new Date()}
                                    />
                                    <label><span className="required">*</span>From Date</label>
                                    {errors.fromDate && <div className="error-message">{errors.fromDate}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="employee-promotion-btn-div">
                        <button type="button" className="employee-promotion-cancel" onClick={handleClear}>
                            Cancel
                        </button>
                        <button type="button" className="employee-promotion-clear" onClick={handleClear}>
                            Clear
                        </button>
                        <button type="button" className="employee-promotion-btn" onClick={handleSave}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Promotion;
